import { useState } from 'react';
import { faqs } from '@/mocks/data';

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  const toggle = (idx: number) => {
    setOpenIdx(openIdx === idx ? null : idx);
  };

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
              常见问题
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto leading-relaxed">
              关于 KY App 下载、安装、使用的常见疑问，这里都有答案
            </p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, idx) => (
              <div
                key={idx}
                className="rounded-2xl bg-background-100 overflow-hidden"
              >
                <button
                  onClick={() => toggle(idx)}
                  className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer hover:bg-background-200/50 transition-colors duration-200"
                >
                  <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                    {faq.q}
                  </span>
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i
                      className={`text-lg text-foreground-400 transition-transform duration-300 ${
                        openIdx === idx ? 'ri-subtract-line rotate-180' : 'ri-add-line'
                      }`}
                    ></i>
                  </div>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIdx === idx ? 'max-h-96 pb-4' : 'max-h-0'
                  }`}
                >
                  <p className="px-6 text-sm text-foreground-500 leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}